/* eslint-disable no-unused-vars */
import { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { Palette } from 'config';

const SLICE_Z_INDEX = 9000;

export const Container = styled.div`
  position: absolute;
  z-index: ${SLICE_Z_INDEX + 1};
  padding: 8px;
  box-shadow: 0px 16px 24px rgba(23, 43, 77, 0.04), 0px 16px 32px rgba(23, 43, 77, 0.08);
  background: #ffffff;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  border-radius: 4px;
  ${({ isOpen }) =>
    isOpen
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : css`
          visibility: hidden;
          opacity: 0;
        `}
  width: ${({ width }) => (width ? `${width}px` : '100%')};
`;

export const Slice = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 2000;
`;

//don't forget to set parent elements position: 'relative'
export const DropDownWrapper = ({
  children,
  width,
  style,
  isOpen$,
  targetRef,
  showSlice = true,
  outSideClickAction = () => {},
  onScrollAction = () => {},
  clickOnSliceAction = () => {},
  sliceStyle,
}) => {
  const dropDownRef = useRef();

  const onScroll = () => {
    isOpen$.value = false;
    onScrollAction();
  };

  const handleClickOutside = (event) => {
    const clickedInsideTrigger = targetRef?.current?.contains(event.target);
    const clickedInsideDropdown = dropDownRef?.current?.contains(event.target);

    if (clickedInsideTrigger || clickedInsideDropdown) return;

    if (isOpen$.value) {
      // small delay to allow option click handlers to fire
      setTimeout(() => {
        isOpen$.value = false;
      }, 200);
      outSideClickAction();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    window.addEventListener('scroll', onScroll, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
      window.removeEventListener('scroll', onScroll, false);
    };
  }, []);

  const clickOnSlice = () => {
    isOpen$.value = false;
    clickOnSliceAction();
  };

  return (
    <>
      {/* {isOpen$.value && showSlice && <Slice style={sliceStyle} onClick={clickOnSlice} />} */}
      <Container
        ref={dropDownRef}
        className='dropdown_base'
        style={style}
        width={width}
        isOpen={isOpen$.value}
      >
        {children}
      </Container>
    </>
  );
};
